// extracted by mini-css-extract-plugin
export default {"album_single_square_picture_div":"CreateAlbumPictureRow_album_single_square_picture_div__lqxUp"};